// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// This is a manifest file that'll be compiled into application.js, which will include all the files
// listed below.
//
// Any JavaScript/Coffee file within this directory, lib/assets/javascripts, or any plugin's
// vendor/assets/javascripts directory can be referenced here using a relative path.
//
// It's not advisable to add code directly here, but if you do, it'll appear at the bottom of the
// compiled file. JavaScript code in this file should be added after the last require_* statement.
//
// Read Sprockets README (https://github.com/rails/sprockets#sprockets-directives) for details
// about supported directives.
//
//= require rails-ujs
//= require activestorage
//= require turbolinks
//= require_tree .

import $ from "jquery";
global.$ = global.jQuery = $;

require("@rails/ujs").start();
// require("@rails/activestorage").start()
// require("channels")
require("components/accordions");
require("components/commons");
require("components/fade-in-scroll");
require("components/header");
require("components/job_items");
require("components/lazyload");
require("components/load_more_news");
require("components/load_more_contests");
require("components/map");
require("components/map_isole_giro");
require("components/menu");
require("components/recipes");
require("components/scroll-to");
require("components/story");
require("components/sliders");
require("components/vertical-nav");
require("components/video");
require("components/xfactor-form");
require("components/xfactor-map");

// Importiamo i CSS di slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import CSSPlugin from "gsap/CSSPlugin";
import { gsap, Power4 } from "gsap"; // Also works with TweenLite and TimelineLite
const myPlugins = [CSSPlugin];
import fadeInScroll from "../components/fade-in-scroll.js";

/// PAGE FADEIN ANIMATION
let fadeInTime;
window.location.pathname == "/" ? (fadeInTime = 3) : (fadeInTime = 0.5);
document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth < 768) {
    fadeInTime = fadeInTime / 3;
  }
  gsap.to(["body", "html"], fadeInTime, { opacity: 1, ease: Power4.easeInOut });
  fadeInScroll();

  watchForHover();
});

function watchForHover() {
  // lastTouchTime is used for ignoring emulated mousemove events
  let lastTouchTime = 0;

  function enableHover() {
    if (new Date() - lastTouchTime < 500) return;
    document.body.classList.add("hasHover");
  }

  function disableHover() {
    document.body.classList.remove("hasHover");
  }

  function updateLastTouchTime() {
    lastTouchTime = new Date();
  }

  document.addEventListener("touchstart", updateLastTouchTime, true);
  document.addEventListener("touchstart", disableHover, true);
  document.addEventListener("mousemove", enableHover, true);

  enableHover();
}
